import { Component, computed, effect, inject } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent, ModalType, SnackbarComponent, ToastType } from '@program-suite/ui';
import { UI_FORM_IMPORTS } from '@program-suite/ui';
import { SelfUserUpdateREQ } from '@program-suite/data-common';
import { AuthStore } from '@program-suite/data-auth';
import { ModalService } from '@program-suite/ui';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ChangePasswordModalComponent } from '@program-suite/ui';


@Component({
  selector: 'lib-user-profile',
  imports: [
    ButtonComponent,
    ...UI_FORM_IMPORTS,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule
],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss',
})
export class UserProfileComponent {
  authStore = inject(AuthStore);
  profileForm!: FormGroup;
  user = computed(() => {
    return this.authStore.user();
  }) 

  constructor(
    private fb: FormBuilder,
    private modalService: ModalService,
  ) {
    this.profileForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.maxLength(50)]],
      lastName: ['', [Validators.required, Validators.maxLength(50)]],
      email: [{ value: '', disabled: true }],
      phone: ['', Validators.required],
    });

    effect(() => {
      const user = this.user();
      if (user) {
        this.profileForm.setValue({
          firstName: user.firstName || '',
          lastName: user.lastName || '',
          email: user.email || '',
          phone: user.phone || '',
        });
      }
    });
    if (this.authStore.isAdmin()) {
      this.profileForm.get('phone')?.setValidators(null);
    }
  }

  changePassword() {
    this.modalService.open(ChangePasswordModalComponent, {modalType: ModalType.Small});
  }

  onSubmit() {
    if (this.profileForm.invalid) {
      return;
    } 
    const user = this.profileForm.value;
    this.authStore.updateUserProfile(user)  
  }
}